import { Carousel } from "react-bootstrap"
import React from "react"
import AbstractMedia from "../components/abstractMedia/AbstractMedia"
import arrow from "../images/arrows/article-arrow.png"
import blackArrow from "../images/arrows/article-black-arrow.png"

function ArticleSlider({ articles, media, lang }) {
  const previousIcon = (
    <div className="article-button-previous">
      <img src={blackArrow} alt="fleche article precedent" />
      <div className="circle" />
    </div>
  )
  const nextIcon = (
    <div className="article-button-next">
      <div className="circle" />
      <img src={blackArrow} alt="fleche article suivant" />
    </div>
  )
  return (
    <div className="article-slider">
      <div className="container">
        <h2 className="purple">
          {lang === "fr" ? "Nos derniers articles" : "Our latest articles"}
        </h2>
        <Carousel
          indicators={false}
          slide
          prevIcon={previousIcon}
          nextIcon={nextIcon}
        >
          {articles.map(article => {
            const splittedDate = article.date
              ? article.date.split("-")
              : ["", "", ""]
            return (
              <Carousel.Item key={`article-${article.id}`}>
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div className="article-slider-item">
                      <a
                        href={`/${article.locale.toLowerCase()}/blog${
                          article.url
                        }`}
                      >
                        <div className="article-list-date">
                          <span className="day">{splittedDate[2]}</span>
                          <span className="month">{splittedDate[1]}</span>
                          <span className="year">{splittedDate[0]}</span>
                        </div>
                        <div className="article-list-image">
                          {article.thumbnailImage && (
                            <AbstractMedia
                              media={media}
                              abstractMedia={article.thumbnailImage}
                              title={article.thumbnailTitle}
                              className="img-fluid"
                            />
                          )}
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div className="article-list-text">
                      <span className="article-list-category">
                        {article.categoryName}
                      </span>
                      <span className="article-list-title">
                        {article.thumbnailTitle}
                      </span>
                      <span
                        className="article-list-description content"
                        dangerouslySetInnerHTML={{
                          __html: article.thumbnailDescription,
                        }}
                      />
                      <a
                        href={`/${article.locale.toLowerCase()}/blog${
                          article.url
                        }`}
                      >
                        <img src={arrow} alt="fleche" />
                        <span>
                          {lang === "fr" ? "LIRE LA SUITE" : "READ MORE"}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            )
          })}
        </Carousel>
      </div>
    </div>
  )
}

export default ArticleSlider
